import * as constantes from './components/constantes.js';

function calcularNota(itens, dividir){
    let i =0;
    let total =0;
    let totalPeso =0;
    let tam=Number(itens.length);
    for(;i<tam; i++){
        if(dividir){
            total = Number(total)+ (Number(itens[i].peso)*Number(itens[i].notaRecebida));
            totalPeso = Number(totalPeso) + Number(itens[i].peso);
        }
        else{
            total= Number(total) +Number(itens[i].notaRecebida);
        }

    }
    if(dividir)
        return isNaN((total/totalPeso))?0:(total/totalPeso).toFixed(2);
    else
        return total.toFixed(2);
}
function validatePDF(file){
    return file.type == 'application/pdf' && file.size <= constantes.PDF_LIMIT;
}
function cpfValidate (strCPF) {
    var Soma = 0
    var Resto = 0
    var i = 0

    if (strCPF == "00000000000") return false
    if (strCPF == "12345678910") return false
    if (strCPF == "11111111111") return false
    if (strCPF == "22222222222") return false

    for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
    Resto = (Soma * 10) % 11

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
    Resto = (Soma * 10) % 11

    if ((Resto == 10) || (Resto == 11))  Resto = 0
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
    return true
}
function verifyCpf (colab,user,colabs, i, ) {

    return  new Promise( (resolve,reject) =>{
        if (colab.user.cpf.length === 11) {
            colab.user.name = '';
            colab.user.email = '';
            colab.user.nome_social = '';
            colab.user.unidade = {};
            colab.user.unidade.id = '';
            colab.user.unidade.centro = {};
            colab.user.unidade.centro.id = '';
            document.getElementById('col_lattes[' + i + ']').value = null;
            document.getElementsByClassName('col_lattes_' + i)[0].innerHTML = '';
            if (cpfValidate(colab.user.cpf)) {
                if (colab.user.cpf == user.cpf)
                    showMsg('O proponente não pode ser colaborador da própria ação!', 0);
                else {
                    var estilo = document.getElementById('spinner').style;

                    estilo.display = null;
                    this.$http.get('/api/usuario/'+colab.user.cpf).then((req) => {
                        var j = colabs.length - 1;
                        var repetido = false;

                        estilo.display = 'none';
                        while (--j >= 0)
                            if (colab.user.cpf == colabs[j].user.cpf) {
                                repetido = true;
                                break
                            }
                        if (req.data && req.data.unidade && !repetido && req.data.perfil && req.data.perfil != this.PERFIL_DISCENTE) {
                            let user={};
                            user.cpf=req.data.cpf;
                            user.name = req.data.name;
                            user.email = req.data.email;
                            user.unidade = req.data.unidade;
                            colab.user_id=req.data.id;
                            if (req.data.nome_social)
                                colab.nome_social = req.data.nome_social;
                            colab.user=user;
                        } else {
                            if (repetido)
                                showMsg('Usuário de CPF ' + colab.user.cpf + ' já está cadastrado como colaborador!', 0);
                            else if (!req.data.perfil || req.data.perfil == this.PERFIL_DISCENTE)
                                showMsg('Usuário de CPF ' + colab.user.cpf + ' não é docente ou técnico de nível D ou E!', 0);
                            else if (req.data)
                                showMsg('Usuário de CPF ' + colab.user.cpf + ' com cadastro incompleto!', 0);
                            else
                                showMsg('Usuário de CPF ' + colab.user.cpf + ' não encontrado!', 0);
                        }
                    })
                   resolve();
                }
            } else{
                showMsg('CPF inválido!', 0);
            }
        }
    });
}
function getNamePdf(path){
    if(path){
        let pathSplited=path.split("/")
        return pathSplited[pathSplited.length-1];
    }
    else
        return "sem arquivo";

}



export {
    verifyCpf,
    validatePDF,
    cpfValidate,
    getNamePdf,
    calcularNota,
};